import React from 'react'
import { CardElement } from '@recurly/react-recurly'
import { colors } from '@pff-consumer/core-ui/src/lib/colors'
import { RecurlyCardElementProps } from './recurly-card-element.props'

const recurlyElementStyle = {
  color: colors.webTextColor,
  fontFamily: 'Roboto, sans-serif',
  placeholder: {
    color: colors.webTextField,
  },
  invalid: {
    fontColor: colors.webErrorColor,
  },
}

export const RecurlyCardElement: React.FC<RecurlyCardElementProps> = (props) => {
  const { className, tabIndex, onChange, onBlur } = props
  return (
    <CardElement
      className={className}
      style={recurlyElementStyle}
      tabIndex={`${tabIndex}`}
      onChange={onChange}
      onBlur={onBlur}
    />
  )
}
